// Generated by CoffeeScript 2.7.0
var MaterialLibraryModal;

import Modal from 'trunks/vue/admin/components/modals/modal.js';

import MaterialLibrary from 'trunks/vue/admin/components/material_library.js';

import Storage from 'libs/storage/index.js';

export default MaterialLibraryModal = Vue.extend({
  components: {
    'modal': Modal,
    'material-library': MaterialLibrary
  },
  props: {
    title: {
      type: String,
      default: '素材库'
    },
    ensureText: {
      type: String,
      default: '插入'
    },
    manage: {
      type: Boolean,
      default: false
    }
  },
  template: `<modal :title='title' class="material-modal" ref='modal'>
  <material-library :materialType="materialType"
                    :totalSize="total_size"
                    :manage="manage"
                    :multiple='multiple'
                    @totalSizeChanged="totalSizeFunc"
                    @materialsChanged="materialsChanged"></material-library>
  <div slot='footer' class="modal-footer" v-if='!manage'>
    <div class="justify-between">
      <div class="storage-space-info gray-text">
        <span class="text">该空间共 10GB 素材空间，您已经使用 {{ totalHumanSize }}，还剩余 9.12GB</span>
        <button class="text-btn">扩容</button>
      </div>
      <div class="force-no-wrap">
        <label class="gray-text force-no-wrap" v-if="materialType == 'image'">
          <input type="checkbox" hidden="true" v-model='origin'/>
          <i class="slp-square-o"></i>
          <span>原图</span>
        </label>
        <button class="outlined btn-default" @click='cancel'>取消</button>
        <button @click='ensure'
                :class="{ disabled: !materials.length}"
                :disabled='!materials.length'>
          {{ ensureText }}
        </button>
      </div>
    </div>
  </div>
  <template slot='footer' v-else></template>
</modal>`,
  data: function() {
    return {
      materials: [],
      origin: false,
      total_size: 0,
      materialType: 'image',
      multiple: true
    };
  },
  computed: {
    totalHumanSize: function() {
      return Skylark.Helpers.FileHelper.humanSize(parseInt(this.total_size));
    }
  },
  methods: {
    getMaterials: function() {
      return Storage.materialsForEditor(this.materials);
    },
    totalSizeFunc: function(totalSize) {
      return this.total_size = totalSize;
    },
    materialsChanged: function(newMaterials) {
      return this.materials = newMaterials;
    },
    ensure: function() {
      this.$refs.modal.close();
      return this.$emit('ensureClicked', this.getMaterials());
    },
    cancel: function() {
      this.$refs.modal.close();
      return this.$emit('cancelClicked', this.getMaterials());
    }
  }
});

export var openMaterialPickModal = function(settings = {}) {
  return new MaterialLibraryModal({
    el: Skylark.Helpers.Utilities.getOrCreateCleaningElementByIdForVue('material_lib'),
    data: settings
  });
};
